import React, { useEffect, useState } from "react";
import { api } from "../shared/axiosInstance";
import ThemeBarChart from "../shared/ThemeBarChart";
import BigFiveChart from "../shared/BigFiveChart";
import { relativeTime } from "../../utils/relativeTime";

const CandidateDetails = ({ candidateId, candidateName, target, targetName, assessmentCompletedAt }) => {

    const [candidateData, setCandidateData] = useState(null);
    const [targetData, setTargetData] = useState(null);

    useEffect(() => {
        const fetchResults = async () => {
            try {
                const candRes = await api.get(`/results/${candidateId}`);
                setCandidateData(candRes.data);

                if (target?._id) {
                    const targetRes = await api.get(`/results/${target._id}`);
                    setTargetData(targetRes.data);
                }
            } catch (err) {
                console.error("❌ Failed to fetch candidate/target results", err);
            }
        };

        if (candidateId) {
            fetchResults();
        }
    }, [candidateId, target]);

    if (!candidateData) return <p className="text-gray-400">Loading graphs...</p>;

    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <div className="bg-bluegray p-4 rounded shadow">
                <h3 className="text-center text-orange font-semibold mb-2">{candidateName}</h3>
                {relativeTime(assessmentCompletedAt) && (
                    <p className="text-sm text-gray-400 text-center mb-2">
                        {relativeTime(assessmentCompletedAt)}
                    </p>
                )}
                <ThemeBarChart
                    themeScores={candidateData.occupationalThemeScores}
                    subscaleScores={candidateData.occupationalSubscaleScores}
                />
                <BigFiveChart bigFiveScores={candidateData.bigFiveScores}/>
            </div>

            {targetData && (
                <div className="bg-bluegray p-4 rounded shadow">
                    <h3 className="text-center text-lightblue font-semibold mb-2">{targetName}</h3>
                    <ThemeBarChart
                        themeScores={targetData.occupationalThemeScores}
                        subscaleScores={targetData.occupationalSubscaleScores}
                    />
                    <BigFiveChart bigFiveScores={targetData.bigFiveScores}/>
                </div>
            )}
        </div>
    );
};
export default CandidateDetails;
